import { StatusMap, VALIDATION_MESSAGE } from '../constants/constants';
import CheckIcon from '@navi/web-ui/lib/icons/CheckIcon';
import CancelCircleFilled from '@cp/src/assets/icons/CancelCircledFilled';
import ClockIcon from '@navi/web-ui/lib/icons/ClockIcon';

export const PAN_VERIFICATION_STATUS_MAP = {
  APPROVED: {
    validationMessage: VALIDATION_MESSAGE.PAN_CARD_STATUS_APPROVED,
    icon: <CheckIcon width={16} height={16} color="var(--green-base)" fill="var(--green-base)" />
  },
  PENDING: {
    validationMessage: VALIDATION_MESSAGE.PAN_CARD_STATUS_PENDING,
    icon: <ClockIcon color="var(--pending-fill-color)" height={16} width={16} />
  },
  REJECTED: {
    validationMessage: VALIDATION_MESSAGE.PAN_CARD_STATUS_REJCETED,
    icon: <CancelCircleFilled fillColor="var(--red-base)" />
  },
  INVALIDATED: {
    validationMessage: VALIDATION_MESSAGE.PAN_CARD_STATUS_INVALIDATED,
    icon: <CancelCircleFilled fillColor="var(--red-base)" />
  }
} as { [key: string]: StatusMap };
